module.exports = __webpack_public_path__ + "6adbf9ee9ed567d3e60998a2ef529825.pdf";